import * as Yup from 'yup';
import { validationMessages } from '../../../utils/FormUtils';
import hashCode from '../../../utils/StringUtil';


const buildValidationSchema = (formatMessage, { globalAriFields, localAriFields }) => {
  const shape = {};

  globalAriFields.forEach((field) => {
    switch (field.inputType) {
      case 'TEXT':
        if (field.mandatory) {
          shape[`global_${field.id}_${hashCode(field.question)}`] = Yup.string()
            .required(formatMessage(validationMessages.required));
        }
        break;
      case 'NUMBER':
        if (field.mandatory) {
          shape[`global_${field.id}_${hashCode(field.question)}`] = Yup
            .number()
            .typeError(formatMessage(validationMessages.notANumber))
            .required(formatMessage(validationMessages.required));
        }
        break;
      case 'DROPDOWN':
        if (field.mandatory) {
          shape[`global_${field.id}_${hashCode(field.question)}`] = Yup.string()
            .required(formatMessage(validationMessages.required));
        }
        break;

      default:
        break;
    }
  });

  localAriFields.forEach((field) => {
    switch (field.inputType) {
      case 'TEXT':
        if (field.mandatory) {
          shape[`local_${field.id}_${hashCode(field.question)}`] = Yup.string()
            .required(formatMessage(validationMessages.required));
        }
        break;
      case 'NUMBER':
        if (field.mandatory) {
          shape[`local_${field.id}_${hashCode(field.question)}`] = Yup
            .number()
            .typeError(formatMessage(validationMessages.notANumber))
            .required(formatMessage(validationMessages.required));
        }
        break;
      case 'DROPDOWN':
        if (field.mandatory) {
          shape[`local_${field.id}_${hashCode(field.question)}`] = Yup.string()
            .required(formatMessage(validationMessages.required));
        }
        break;

      default:
        break;
    }
  });

  return Yup.object().shape(shape);
};

export default buildValidationSchema;
